function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#90b21d",
  d: "M9.107 4.107H6.071a.179.179 0 01-.179-.179V.893a.893.893 0 10-1.786 0v3.036a.179.179 0 01-.179.179H.893a.893.893 0 100 1.786h3.036a.179.179 0 01.179.179v3.034a.893.893 0 001.786 0V6.071a.179.179 0 01.179-.179h3.034a.893.893 0 000-1.786zm0 0"
});

function SvgAdd2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgdmlld0JveD0iMCAwIDEwIDEwIj4KICAgIDxwYXRoIGZpbGw9IiM5MGIyMWQiIGQ9Ik05LjEwNyA0LjEwN0g2LjA3MWEuMTc5LjE3OSAwIDAgMS0uMTc5LS4xNzlWLjg5M2EuODkzLjg5MyAwIDEgMC0xLjc4NiAwdjMuMDM2YS4xNzkuMTc5IDAgMCAxLS4xNzkuMTc5SC44OTNhLjg5My44OTMgMCAxIDAgMCAxLjc4NmgzLjAzNmEuMTc5LjE3OSAwIDAgMSAuMTc5LjE3OXYzLjAzNGEuODkzLjg5MyAwIDAgMCAxLjc4NiAwVjYuMDcxYS4xNzkuMTc5IDAgMCAxIC4xNzktLjE3OWgzLjAzNGEuODkzLjg5MyAwIDAgMCAwLTEuNzg2em0wIDAiLz4KPC9zdmc+Cg==";
export { SvgAdd2 as ReactComponent };